import { createTPAxios, createAxios } from '@/api/axios.ts';

const useTPAxios = () => {
  return createTPAxios();
};

const useAxios = () => {
  return createAxios();
};

export { useTPAxios, useAxios };
